// extracted by mini-css-extract-plugin
export default {"trigger":"nD9TmBrPnN_zj3sv8Z4w","locale_container":"vA3ySC1bOYjn7e1ZFYxf","locale_origin_name":"bGJy6umtL9dLzjvJKWkm","locale_translated_name":"hiwFmNBkzRCyugUiDjLg"};